/**
 * Gravitee.io Portal Rest API
 * API dedicated to the devportal part of Gravitee
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: contact@graviteesource.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HttpMethod = 'CONNECT' | 'DELETE' | 'GET' | 'HEAD' | 'OPTIONS' | 'PATCH' | 'POST' | 'PUT' | 'TRACE' | 'OTHER';

export const HttpMethod = {
    CONNECT: 'CONNECT' as HttpMethod,
    DELETE: 'DELETE' as HttpMethod,
    GET: 'GET' as HttpMethod,
    HEAD: 'HEAD' as HttpMethod,
    OPTIONS: 'OPTIONS' as HttpMethod,
    PATCH: 'PATCH' as HttpMethod,
    POST: 'POST' as HttpMethod,
    PUT: 'PUT' as HttpMethod,
    TRACE: 'TRACE' as HttpMethod,
    OTHER: 'OTHER' as HttpMethod
};

